<p *ngIf="hasWallet" class="msg">Your account already has a wallet associated with it. </p>
<p *ngIf="noWallet" class="msg">We are creating a crypto wallet for you... <br>You will be redirected to profile settings after wallet creation.</p>

